import React, { Component } from "react";
import {
	View,
	Animated,
	Text,
	Easing,
	StyleSheet,
	Platform,
} from "react-native";
import { translate } from "react-i18next";

import Plug from "components/svgs/Plug";
import Hexagon from "components/svgs/Hexagon";

import * as x from "../../styles/css";

class Gauge extends Component {
	constructor(props) {
		super(props);

		this.minValue = 1;
		this.maxValue = 20;

		this.state = {
			degree: new Animated.Value(this.minValue),
		};

		this.start = this.start.bind(this);
		this.animation = null;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.loading != this.props.loading && nextProps.loading) {
			this.start();
		}
	}

	start() {
		this.state.degree.setValue(this.minValue);
		Animated.sequence([
			Animated.timing(this.state.degree, {
				toValue: this.maxValue,
				easing: Easing.inOut(Easing.ease),
				duration: 3000,
			}),
			Animated.timing(this.state.degree, {
				toValue: this.minValue,
				easing: Easing.inOut(Easing.ease),
				duration: 1,
			}),
		]).start(ani => {
			if (ani.finished && this.props.loading) {
				this.start();
			}
		});
	}

	render() {
		const { t } = this.props;

		const pulseColor = this.props.pulseColor || x.colors.primaryDark;

		const deg = this.state.degree.interpolate({
			inputRange: [this.minValue, this.maxValue],
			outputRange: ["20deg", "380deg"],
			extrapolate: "clamp",
		});

		const degTwo = this.state.degree.interpolate({
			inputRange: [this.minValue, this.maxValue / 2, this.maxValue],
			outputRange: ["280deg", "95deg", "0deg"],
			extrapolate: "clamp",
		});

		const textColor = this.props.textColor
			? { color: this.props.textColor }
			: {};

		return (
			<Animated.View
				style={[
					x.alignItems.center,
					x.justifyContent.center,
					this.props.style ? { ...this.props.style } : {},
				]}
			>
				<Animated.View style={[x.flexDirection.row]}>
					<Animated.View>
						<Animated.View
							style={{
								transform: [{ rotate: "280deg" }],
							}}
						>
							<Hexagon opacity={"0.25"} fill={"white"} />
						</Animated.View>
						<Animated.View
							style={{
								position: "absolute",
								left: 0,
								top: 0,
							}}
						>
							<Animated.View
								style={{ transform: [{ rotate: deg }] }}
							>
								<Hexagon
									opacity={"0.65"}
									fill={this.props.pulseColor}
								/>
							</Animated.View>
						</Animated.View>
						{this.props.connected ? (
							<View style={[styles.gauge]}>
								<View>
									<View
										style={[
											x.justifyContent.center,
											x.flexDirection.row,
										]}
									>
										<Text style={[styles.value, textColor]}>
											{this.props.desiredValue}
										</Text>

										<Text
											style={[
												styles.operation,
												textColor,
											]}
										>
											{this.props.operation
												? this.props.operation
												: "%"}
										</Text>
									</View>

									<Text style={[styles.name, textColor]}>
										{this.props.name}
									</Text>
								</View>
							</View>
						) : (
							<View style={[styles.gauge]}>
								<View
									style={[
										x.d.flex,
										x.justifyContent.center,
										x.alignItems.center,
									]}
								>
									<View>
										<Plug fill="black" scale={4} />
									</View>
									<Text
										style={[
											styles.name,
											x.mt.three,
											textColor,
										]}
									>
										{this.props.name || t("labels.offline")}
									</Text>
								</View>
							</View>
						)}
					</Animated.View>
				</Animated.View>
			</Animated.View>
		);
	}
}

const styles = StyleSheet.create({
	value: {
		marginTop: 24,
		color: "black",
		fontSize: 74,
		backgroundColor: "rgba(0,0,0,0)",
		textAlign: "center",
	},
	name: {
		color: "black",
		fontSize: 16,
		backgroundColor: "rgba(0,0,0,0)",
		textAlign: "center",
	},
	gauge: {
		position: "absolute",
		top: 16,
		left: 6,
		bottom: 5,
		backgroundColor: "white",
		width: "92%",
		height: "84%",
		borderRadius: 80,
	},
	operation: {
		color: "black",
		marginTop: 40,
		fontSize: 16,
		backgroundColor: "rgba(0,0,0,0)",
		textAlign: "center",
	},
});

export default translate()(Gauge);



// WEBPACK FOOTER //
// ./src/components/Gauge/index.js